import React, { useState } from "react"
import { Trash2 } from "lucide-mui"
import i18n from "@/i18n"
import { useMutation } from "@apollo/client/react"
import { RemoveReservationDocument } from "@/graphql/graphql"
import LoadingButton from "@mui/lab/LoadingButton"
import { UPDATE_RESERVATION_REFETCH_QUERIES } from "@/graphql/dependencies"

interface RemoveButtonProps {
  reservation: { id: string }
  setError: (error: string) => void
  onSuccess: () => void
}

const RemoveButton: React.FC<RemoveButtonProps> = ({ reservation, setError, onSuccess }) => {
  const [removeReservation, { loading: removing }] = useMutation(RemoveReservationDocument, {
    refetchQueries: UPDATE_RESERVATION_REFETCH_QUERIES,
  })

  const [justRemoved, setJustRemoved] = useState(false)

  const onRemove = async () => {
    const result = await removeReservation({
      variables: {
        reservationId: reservation.id,
      },
    })
    const success = result?.data?.removeReservation?.success

    if (success) {
      setJustRemoved(true)
      onSuccess()
    } else {
      setError(i18n.t("app.reservation_preview.remove_error"))
    }
  }

  return (
    <LoadingButton
      color="error"
      loadingPosition="center"
      loading={removing}
      onClick={onRemove}
      data-testid="panel-reservations-remove-btn"
    >
      {justRemoved ? <Trash2 className="text-base" /> : "Delete"}
    </LoadingButton>
  )
}

export default RemoveButton
